var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.427,
    height: 13.424,
    viewBox: "0 0 13.427 13.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save",
    d: "M76.063,78.156h-10.7a.85.85,0,0,0-.084-.027,1.524,1.524,0,0,1-1.06-.757,4.042,4.042,0,0,1-.22-.579V66.1a.792.792,0,0,0,.027-.085,1.571,1.571,0,0,1,1.52-1.277q4.692-.005,9.384,0a.247.247,0,0,1,.157.066q1.139,1.131,2.271,2.27a.247.247,0,0,1,.066.157q0,4.691,0,9.382a1.517,1.517,0,0,1-.614,1.22A1.893,1.893,0,0,1,76.063,78.156ZM67.068,65.781H65.68c-.438,0-.631.193-.631.629q0,5.034,0,10.067c0,.044,0,.087,0,.131a.489.489,0,0,0,.372.469,4.568,4.568,0,0,0,.6.039V76.93q0-2.189,0-4.378a1.575,1.575,0,0,1,1.638-1.632h6.136a1.575,1.575,0,0,1,1.64,1.643q0,2.189,0,4.378v.166H75.8a.53.53,0,0,0,.581-.575q0-4.424,0-8.848a.3.3,0,0,0-.08-.19c-.534-.541-1.075-1.075-1.609-1.617a.281.281,0,0,0-.3-.083v.139q0,1.167,0,2.333a1.573,1.573,0,0,1-1.6,1.6q-2.058,0-4.117,0a1.664,1.664,0,0,1-.388-.046,1.562,1.562,0,0,1-1.21-1.545C67.067,67.453,67.068,66.627,67.068,65.781Zm0,11.317h7.316v-.139q0-2.2,0-4.391a.534.534,0,0,0-.6-.6H67.665a.534.534,0,0,0-.6.6q0,2.2,0,4.391Zm1.049-11.31v.137q0,1.153,0,2.306a.532.532,0,0,0,.591.591h4.037a.533.533,0,0,0,.591-.591q0-1.153,0-2.306v-.137H72.285v1.976h-1.05V65.788Z",
    transform: "translate(-64 -64.732)",
    fill: "#5a5a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.c4bf12bd65f019be6c155ac7023fd34a.svg";
export { ForwardRef as ReactComponent };